import * as React from 'react'

import { cn } from '@/lib/utils'

function Table({ className, fixedHeader = false, maxHeight = '20rem', ...props }) {
    if (fixedHeader) {
        return (
            <div data-slot="table-container" className="tw:relative tw:w-full">
                <div className="tw:overflow-auto" style={{ maxHeight }}>
                    <table data-slot="table" className={cn('tw:w-full tw:caption-bottom tw:text-sm', className)} {...props}>
                        {React.Children.map(props.children, child => {
                            if (child?.type?.name === 'TableHeader' || child?.props?.['data-slot'] === 'table-header') {
                                return React.cloneElement(child, {
                                    className: cn(child.props.className, 'tw:sticky tw:top-0 tw:z-10 tw:bg-secondary-background')
                                })
                            }
                            return child
                        })}
                    </table>
                </div>
            </div>
        )
    }

    return (
        <div data-slot="table-container" className="tw:relative tw:w-full tw:overflow-x-auto">
            <table data-slot="table" className={cn('tw:w-full tw:caption-bottom tw:text-sm', className)} {...props} />
        </div>
    )
}

function TableHeader({ className, ...props }) {
    return <thead data-slot="table-header" className={cn('tw:[&_tr]:border-b', className)} {...props} />
}

function TableBody({ className, ...props }) {
    return <tbody data-slot="table-body" className={cn('tw:[&_tr:last-child]:border-0', className)} {...props} />
}

function TableFooter({ className, ...props }) {
    return (
        <tfoot
            data-slot="table-footer"
            className={cn('tw:bg-muted/50 tw:border-t tw:font-medium tw:[&>tr]:last:border-b-0', className)}
            {...props}
        />
    )
}

function TableRow({ className, ...props }) {
    return (
        <tr
            data-slot="table-row"
            className={cn('tw:data-[state=selected]:bg-muted tw:!border-b tw:transition-colors', className)}
            {...props}
        />
    )
}

function TableHead({ className, ...props }) {
    return (
        <th
            data-slot="table-head"
            className={cn(
                'tw:text-foreground tw:h-10 tw:px-2 tw:text-left tw:align-middle tw:!font-semibold tw:whitespace-nowrap tw:[&:has([role=checkbox])]:pr-0 tw:[&>[role=checkbox]]:translate-y-[2px]',
                className,
            )}
            {...props}
        />
    )
}

function TableCell({ className, ...props }) {
    return (
        <td
            data-slot="table-cell"
            className={cn(
                'tw:p-2 tw:align-middle tw:whitespace-nowrap tw:[&:has([role=checkbox])]:pr-0 tw:[&>[role=checkbox]]:translate-y-[2px]',
                className,
            )}
            {...props}
        />
    )
}

function TableCaption({ className, ...props }) {
    return (
        <caption
            data-slot="table-caption"
            className={cn('tw:text-muted-foreground tw:mt-4 tw:text-sm', className)}
            {...props}
        />
    )
}

export { Table, TableHeader, TableBody, TableFooter, TableHead, TableRow, TableCell, TableCaption }
